import RestoreIcon from '@mui/icons-material/Restore';
import { useTranslation } from 'react-i18next';
import { TargetCardConfig } from './MiViewTargetCard.types';

const useMiViewTargetCardConfig = () => {
  const { t } = useTranslation();

  const targetCardConfig: TargetCardConfig = {
    menuList: [
      {
        label: t('maya_miview_menu_item_action'),
        clickAction: () => null,
      },
      {
        label: t('maya_miview_menu_item_change_details'),
        clickAction: () => null,
        icon: RestoreIcon,
      },
    ],
  };

  return { targetCardConfig };
};

export default useMiViewTargetCardConfig;
